import { render, staticRenderFns } from "./OtherLogin.vue?vue&type=template&id=74f4f6ae&scoped=true"
import script from "./OtherLogin.vue?vue&type=script&lang=js"
export * from "./OtherLogin.vue?vue&type=script&lang=js"
import style0 from "./OtherLogin.vue?vue&type=style&index=0&id=74f4f6ae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74f4f6ae",
  null
  
)

export default component.exports